import { appendQsParams, get, post } from 'lib/request';

export const getLastThreadsCategoryList = async ({ threadSlug, limit, page }) =>
  get(
    appendQsParams(`/thread/category/${threadSlug}/threads`, {
      limit,
      page,
    })
  );

export const getThreadCategoriesList = async () => get('/thread/categories');

export const getThreadInfo = async ({ threadSlug }, opts) =>
  get(`/thread/${threadSlug}`, opts);

export const postThreadLike = async ({ threadId }) =>
  post(`/thread/${threadId}/like`);

export const getThreadsList = async ({ limit, page } = {}) =>
  get(appendQsParams('/threads', { limit, page }));

export const getThreadRating = async ({ threadId }, opts) =>
  get(`/thread/${threadId}/rating`, opts);

export const getUserThreadSubscription = async ({ threadId }, opts) =>
  get(`/thread/${threadId}/subscription`, opts);

export const postNewThread = async ({
  threadSubscription,
  threadText,
  threadTitle,
  threadTypeName,
}) =>
  post('/thread', {
    body: {
      threadTitle,
      threadText,
      threadSubscription,
      threadTypeName,
    },
  });

export const postMarkThreadSolved = async ({ threadId }) =>
  post(`/thread/${threadId}/solved`);

export const postSubscribeUserThread = async ({ threadId }) =>
  post(`/thread/${threadId}/subscription`);
